import _toConsumableArray from "D:/wwwroot/dealer-web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "D:/wwwroot/dealer-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.concat.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import JsBarcode from 'jsbarcode';
import printJs from 'print-js';
import dayjs from 'dayjs';
import { findConfig } from '@/api/settings';
import TableHeadComponent from '@/views/components/drag/fields.vue';
import * as XLSX from 'xlsx-js-style';
import { saveAs } from 'file-saver';
import { findReportOrder, listReportOrderDetail } from '@/api/report.js';
export default {
  components: {
    TableHeadComponent: TableHeadComponent
  },
  data: function data() {
    return {
      dialogTitle: '打印预览',
      dialogVisible: false,
      detailList: [],
      tableLoading: false,
      orderRow: {},
      companyDetail: {},
      serviceName: '',
      loading: true,
      cacheName: '',
      remoteColumnsList: [],
      localColumnsList: [{
        prop: 'productNumber',
        label: '产品编号',
        type: 'string',
        summary: false,
        checked: true
      }, {
        prop: 'productName',
        label: '物资名称',
        type: 'string',
        summary: false,
        checked: true
      }, {
        prop: 'specificationModel',
        label: '规格型号',
        type: 'string',
        summary: false,
        checked: true
      }, {
        prop: 'batchNumber',
        label: '生产批号',
        type: 'string',
        summary: false,
        checked: true
      }, {
        prop: 'trackingCode',
        label: '序列号',
        type: 'string',
        summary: false,
        checked: true
      }, {
        prop: 'unit',
        label: '单位',
        type: 'string',
        summary: false,
        checked: true
      }, {
        prop: 'deliveryQuantity',
        label: '数量',
        type: 'integer',
        summary: true,
        checked: true
      }, {
        prop: 'hospitalUnitPrice',
        label: '单价',
        type: 'money',
        summary: true,
        checked: true
      }, {
        prop: 'hospitalSumPrice',
        label: '单价小计',
        type: 'money',
        summary: true,
        checked: true
      }, {
        prop: 'surgeon',
        label: '医生姓名',
        type: 'string',
        summary: false,
        checked: true
      }, {
        prop: 'patientName',
        label: '病人姓名',
        type: 'string',
        summary: false,
        checked: true
      }, {
        prop: 'patientGender',
        label: '病人性别',
        type: 'string',
        summary: false,
        checked: true
      }, {
        prop: 'patientAge',
        label: '病人年龄',
        type: 'string',
        summary: false,
        checked: true
      }, {
        prop: 'operationTime',
        label: '手术日期',
        type: 'string',
        summary: false,
        checked: true
      }, {
        prop: 'admissionNumber',
        label: '住院号',
        type: 'string',
        summary: false,
        checked: true
      }, {
        prop: 'registrationNumber',
        label: '注册证号',
        type: 'string',
        summary: false,
        checked: true
      }, {
        prop: 'manufacturer',
        label: '生产厂家',
        type: 'string',
        summary: false,
        checked: true
      }]
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.cacheName = 'SC-' + this.$route.name + '-print';
  },
  methods: {
    init: function init(id) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var that, colList, findRes;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                that = _this;
                that.dialogVisible = true;
                colList = that.localColumnsList;
                _context.next = 5;
                return findConfig({
                  key: that.cacheName
                });

              case 5:
                findRes = _context.sent;

                if (findRes.reconfig.key) {
                  that.remoteColumnsList = JSON.parse(findRes.reconfig.value);
                  colList.map(function (item) {
                    var findRow = that.remoteColumnsList.find(function (item2) {
                      return item2.prop === item.prop;
                    });

                    if (!findRow) {
                      that.remoteColumnsList.push(item);
                    } else {
                      findRow.label = item.label;
                      findRow.type = item.type;
                      findRow.summary = item.summary;
                    }
                  });
                } else {
                  that.remoteColumnsList = colList;
                }

                that.loading = true; // 查找入库单

                _context.next = 10;
                return findReportOrder({
                  id: id
                }).then(function (res) {
                  that.orderRow = res.retradeOrder;
                }).catch(function () {});

              case 10:
                _context.next = 12;
                return listReportOrderDetail({
                  page: 1,
                  pageSize: 9999,
                  deliveryId: id
                }).then(function (res) {
                  that.detailList = that.detailListFormat(res.list);
                  var num = 0;
                  that.detailList.forEach(function (row) {
                    num = num + row.quantityUsed * row.salesUnitPrice;
                    row.subtotal = (row.quantityUsed * row.salesUnitPrice).toFixed(2);
                    row.afterTaxPriceSum = (row.quantityUsed * row.afterTaxPrice).toFixed(2);
                  });
                  num = num.toFixed(2);
                }).catch(function () {});

              case 12:
                that.loading = false;
                that.$nextTick(function () {
                  JsBarcode('#barcode', that.orderRow.deliveryOrderNo, {
                    height: 35,
                    margin: 0,
                    fontSize: 14,
                    width: 1,
                    fontOptions: 'bold'
                  });
                }); // 处理不同报台类型时显示的字段

                that.remoteColumnsList.map(function (row) {
                  if (['surgicalName', 'admissionNumber', 'operationTime', 'patientAge', 'patientGender', 'patientName', 'surgeon'].includes(row.prop)) {
                    console.log('包含', row.prop);

                    if (that.orderRow.multi === 1) {
                      that.$set(row, 'checked', false);
                    } else if (that.orderRow.multi === 2) {
                      that.$set(row, 'checked', true);
                    }
                  }
                });

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    dialogClose: function dialogClose() {
      var that = this;
      that.dialogVisible = false;
    },
    printClick: function printClick() {
      // 打印
      printJs({
        printable: 'printContainerConsign',
        // 所有数据
        type: 'html',
        scanStyles: false,
        css: '/style/print.css' // style:'@media print{@page {size:landscape}}' //横行打印

      });
    },
    detailListFormat: function detailListFormat(rows) {
      var resultRows = [];
      rows.forEach(function (row, index) {
        resultRows.push({
          id: row.ID,
          productName: row.main.productName,
          productNumber: row.specs.productNumber,
          specificationModel: row.specs.specificationModel,
          unit: row.specs.unit,
          deliveryQuantity: row.deliveryQuantity,
          hospitalUnitPrice: row.hospitalUnitPrice,
          hospitalSumPrice: row.hospitalSumPrice,
          registrationNumber: row.main.registrationNumber,
          manufacturer: row.main.manufacturer,
          brandName: row.main.brandName,
          remarks: row.remarks,
          batchNumber: row.inventory.batch_number,
          trackingCode: row.inventory.trackingCode,
          surgeon: row.surgeon,
          patientName: row.patientName,
          patientGender: row.patientGender,
          patientAge: row.patientAge,
          admissionNumber: row.admissionNumber,
          operationTime: row.operationTime
        });
      });
      return resultRows;
    },
    saveTableSet: function saveTableSet(val) {
      var that = this;
      that.remoteColumnsList = val;
    },
    getSummary: function getSummary() {
      var that = this;
      var summaryData = {};
      that.detailList.forEach(function (row) {
        that.remoteColumnsList.forEach(function (row1) {
          if (row1.type === 'integer' || row1.type === 'money') {
            if (row1.summary === true) {
              summaryData[row1.prop] = summaryData[row1.prop] ? Number(summaryData[row1.prop]) + Number(row[row1.prop]) : Number(row[row1.prop]);

              if (row1.type === 'money') {
                summaryData[row1.prop] = Number(summaryData[row1.prop]).toFixed(2);
              }
            }
          } else {
            summaryData[row1.prop] = '';
          }
        });
      });
      var find = that.remoteColumnsList.filter(function (row) {
        return row.checked === true;
      });
      summaryData[find[0].prop] = '合计';
      var result = [];
      result.push(summaryData);
      return result;
    },
    dataFormatter: function dataFormatter(val, type) {
      if (type === 'money') {
        val = val ? Number(val).toFixed(2) : val;
      } else if (type === 'integer') {
        val = val ? parseInt(val) : val;
      } else if (type === 'date') {
        if (val.length === 8) {
          val = dayjs().format('YYYY').substr(0, 2) + val;
        }

        val = val ? dayjs(val).format('YYYY-MM-DD') : null;
      }

      return val;
    },
    excelKey: function excelKey(index) {
      var charList = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
      return charList[index];
    },
    paddingVal: function paddingVal(num, style) {
      var result = [];

      for (var i = 1; i <= num; i++) {
        result.push({
          t: 's',
          v: '',
          s: style
        });
      }

      return result;
    },
    exportExcel: function exportExcel() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var that, border, tableHeaderStyle, rowStyle, titleStyle, sumRowStyle, formStyle, fields, leftMerges, leftPadding, rightPadding, data, tableHeaderData, sumRow, merges, i, ws, _i, wb, excelBuffer, blob;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                that = _this2; // 定义边框样式

                border = {
                  top: {
                    style: 'thin'
                  },
                  bottom: {
                    style: 'thin'
                  },
                  left: {
                    style: 'thin'
                  },
                  right: {
                    style: 'thin'
                  }
                };
                tableHeaderStyle = {
                  alignment: {
                    horizontal: 'center',
                    // 水平居中
                    vertical: 'center' // 竖直居中

                  },
                  font: {
                    bold: true
                  },
                  fill: {
                    fgColor: {
                      rgb: 'E9E9E9'
                    }
                  },
                  border: border
                };
                rowStyle = {
                  alignment: {
                    horizontal: 'center',
                    // 水平居中
                    vertical: 'center' // 竖直居中

                  },
                  border: border
                };
                titleStyle = {
                  alignment: {
                    wrapText: true,
                    horizontal: 'center',
                    // 水平居中
                    vertical: 'center' // 竖直居中

                  },
                  font: {
                    bold: true,
                    sz: 14
                  }
                };
                sumRowStyle = {
                  alignment: {
                    horizontal: 'center',
                    // 水平居中
                    vertical: 'center' // 竖直居中

                  },
                  font: {
                    bold: true,
                    color: {
                      rgb: 'FF0000'
                    }
                  },
                  border: border
                };
                formStyle = {
                  alignment: {
                    horizontal: 'left',
                    // 水平居中
                    vertical: 'center' // 竖直居中

                  }
                };
                fields = that.remoteColumnsList.filter(function (item) {
                  return item.checked === true;
                });
                leftMerges = Math.floor(fields.length / 2);
                leftPadding = that.paddingVal(leftMerges - 1, formStyle);
                rightPadding = that.paddingVal(fields.length - leftMerges - 1, formStyle);
                data = [[{
                  t: 's',
                  v: "".concat(that.orderRow.manu.name, "\r\n\u62A5\u53F0\u5355"),
                  s: titleStyle
                }].concat(_toConsumableArray(that.paddingVal(fields.length - 1, titleStyle)))]; // 添加表单数据

                data.push([{
                  t: 's',
                  v: "\u7ECF\u9500\u5546\uFF1A".concat(that.orderRow.manu.name),
                  s: formStyle
                }].concat(_toConsumableArray(leftPadding), [{
                  t: 's',
                  v: "\u8BA2\u5355\u7F16\u53F7\uFF1A".concat(that.orderRow.deliveryOrderNo),
                  s: formStyle
                }], _toConsumableArray(rightPadding)), [{
                  t: 's',
                  v: '客户类型：',
                  s: formStyle
                }].concat(_toConsumableArray(leftPadding), [{
                  t: 's',
                  v: '客户名称：',
                  s: formStyle
                }], _toConsumableArray(rightPadding)), [{
                  t: 's',
                  v: "\u4F9B\u5E94\u5546\uFF1A".concat(that.orderRow.organizationName),
                  s: formStyle
                }].concat(_toConsumableArray(leftPadding), [{
                  t: 's',
                  v: "\u6536\u4EF6\u4EBA\uFF1A".concat(that.orderRow.receiveName),
                  s: formStyle
                }], _toConsumableArray(rightPadding)), [{
                  t: 's',
                  v: "\u8054\u7CFB\u65B9\u5F0F\uFF1A".concat(that.orderRow.contactInfo),
                  s: formStyle
                }].concat(_toConsumableArray(leftPadding), [{
                  t: 's',
                  v: "\u6536\u8D27\u5730\u5740\uFF1A".concat(that.orderRow.receiveAddress),
                  s: formStyle
                }], _toConsumableArray(rightPadding)), [{
                  t: 's',
                  v: "\u5907\u6CE8\uFF1A".concat(that.orderRow.remarks),
                  s: formStyle
                }].concat(_toConsumableArray(that.paddingVal(fields.length - 2, formStyle)))); // 添加表头数据

                tableHeaderData = [];
                fields.forEach(function (item) {
                  tableHeaderData.push({
                    t: 's',
                    v: item.label,
                    s: tableHeaderStyle
                  });
                });
                data.push(tableHeaderData); // 添加表格数据

                that.detailList.forEach(function (item) {
                  var newRow = [];
                  fields.forEach(function (item2) {
                    newRow.push({
                      t: 's',
                      v: item[item2.prop],
                      s: rowStyle
                    });
                  });
                  data.push(newRow);
                }); // 添加合计数据

                sumRow = that.getSummary();
                sumRow.forEach(function (row) {
                  var newRow = [];
                  fields.forEach(function (row2) {
                    newRow.push({
                      t: 's',
                      v: row[row2.prop],
                      s: sumRowStyle
                    });
                  });
                  data.push(newRow);
                });
                merges = [{
                  s: {
                    r: 0,
                    c: 0
                  },
                  e: {
                    r: 0,
                    c: fields.length - 1
                  }
                }]; // 设置表单合并单元格

                for (i = 1; i <= 5; i++) {
                  merges.push({
                    s: {
                      r: i,
                      c: 0
                    },
                    e: {
                      r: i,
                      c: leftMerges - 1
                    }
                  });
                  merges.push({
                    s: {
                      r: i,
                      c: leftMerges
                    },
                    e: {
                      r: i,
                      c: fields.length - 1
                    }
                  });
                }

                ws = XLSX.utils.aoa_to_sheet(data, {
                  raw: true,
                  cellDates: true,
                  sheetMerges: merges
                }); // 设置列宽

                ws['!cols'] = [];
                fields.forEach(function (item) {
                  ws['!cols'].push({
                    wch: 15
                  });
                }); // 设置行高

                ws['!rows'] = [{
                  hpx: 60
                }];

                for (_i = 1; _i <= 10; _i++) {
                  ws['!rows'].push({
                    hpx: 20
                  });
                }

                that.detailList.forEach(function (row) {
                  ws['!rows'].push({
                    hpx: 20
                  });
                });
                ws['!merges'] = merges;
                wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
                excelBuffer = XLSX.write(wb, {
                  type: 'array',
                  bookType: 'xlsx'
                });
                blob = new Blob([excelBuffer], {
                  type: 'application/octet-stream'
                });
                saveAs(blob, '寄售订货订单.xlsx');

              case 33:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  }
};